import { useQuery } from '@tanstack/react-query';
import { useNavigate, Link as RouterLink } from 'react-router-dom';
import { Button, Chip, Alert } from '@mui/material';
import { OpenInNew } from '@mui/icons-material';
import { GridColDef } from '@mui/x-data-grid';
import PageShell from '../../components/layout/PageShell';
import PageHeader from '../../components/layout/PageHeader';
import DataTableCard from '../../components/ui/DataTableCard';
import EnhancedDataGrid from '../../components/ui/EnhancedDataGrid';
import RowActions from '../../components/ui/RowActions';
import { listHubServices } from '../../services/serviceHubService';

export default function TransportServicesPage() {
  const navigate = useNavigate();

  const { data: services = [], isLoading } = useQuery({
    queryKey: ['transport-hub-services'],
    queryFn: () => listHubServices('transport'),
  });

  const columns: GridColDef[] = [
    { field: 'name', headerName: 'Sub-Service', flex: 1, minWidth: 160 },
    { field: 'slug', headerName: 'Slug', width: 140 },
    { field: 'serviceCode', headerName: 'Code', width: 120 },
    {
      field: 'isActive', headerName: 'Status', width: 90,
      renderCell: (p) => (
        <Chip size="small" label={p.row.isActive !== false ? 'Active' : 'Inactive'} color={p.row.isActive !== false ? 'success' : 'default'} />
      ),
    },
    {
      field: 'actions', headerName: 'Actions', width: 120, sortable: false,
      renderCell: (params) => (
        <RowActions onEdit={() => navigate(`/hubs/transport/${params.row.slug}`)} />
      ),
    },
  ];

  return (
    <PageShell>
      <PageHeader
        eyebrow="Transport"
        title="Transport Sub-Services"
        subtitle="Dynamic bookable services from Transport Hub — zone pricing, not Ride Category masters"
        actions={
          <Button component={RouterLink} to="/hubs/transport" variant="contained" endIcon={<OpenInNew fontSize="small" />}>
            Open Transport Hub
          </Button>
        }
      />
      <Alert severity="info" sx={{ mb: 2 }}>
        Ride Category master is not used. Each row below is a live sub-service (bike-ride, taxi-ride, …).
        Set fares in <RouterLink to="/zones">Zone Management</RouterLink> and masters per slug under each service.
      </Alert>
      <DataTableCard title="Sub-Service Catalog">
        <EnhancedDataGrid
          rows={services}
          columns={columns}
          loading={isLoading}
          getRowId={(r) => r._id}
          autoHeight
          exportFileName="transport-sub-services"
        />
      </DataTableCard>
    </PageShell>
  );
}
